module.exports = __webpack_public_path__ + "static/img/overall-health-result.5414ee4.png";


//////////////////
// WEBPACK FOOTER
// ./static/website/images/overall-health-result.png
// module id = vt0Y
// module chunks = 1